import React from 'react';
import { Icon, Segment } from 'semantic-ui-react';

import { getFileEtx } from 'src/utils/helper';

type Props = {
  classTopic?: Model.ClassTopic;
};

const ModelAnswer: React.FC<Props> = ({ classTopic }) => {
  return (
    <React.Fragment>
      {classTopic?.model_answer_url && (
        <Segment className="p-24 border d-flex-between mb-36">
          <a
            href={classTopic.model_answer_url}
            target="_blank"
            rel="noreferrer"
          >
            <Icon size="large" name={getFileEtx(classTopic.model_answer_url)} />{' '}
            {classTopic.assignment_answer_url}
          </a>
        </Segment>
      )}
    </React.Fragment>
  );
};

export default ModelAnswer;
